import $ from 'jquery'
import prop from 'vue-strict-prop'
import { component, modifiers as m } from 'vue-tsx-support'

export default component({
	name: 'Form',
	props: {
		fields: prop.ofType<SemanticUI.Fields>().optional,
		/**
		 * Event used to trigger validation.
		 */
		on: prop.ofStringLiterals('blur', 'change', 'submit').default('submit'),
	},
	mounted(): void {
		const vm = this

		$(this.$el).form({
			fields: this.fields,
			on: this.on,
			onFailure: (formErrors, fields) => vm.$emit('failure', this, formErrors, fields),
			onInvalid: () => vm.$emit('invalid', this),
			onSuccess: (event, fields) => vm.$emit('success', this, event, fields),
			onValid: () => vm.$emit('valid', this),
		})
	},
	methods: {
		/**
		 * Remove all values from form fields and reset dropdowns to placeholder
		 * text.
		 */
		clear(): void {
			$(this.$el).form('clear')
		},
		/**
		 * Returns value of element with id.
		 */
		getValue(id: string): string {
			return $(this.$el).form('get value', id)
		},
		/**
		 * Returns object of element values that match array of ids. If no ids
		 * are passed will return all fields
		 */
		getValues(ids?: string[]): SemanticUI.FormValues {
			return $(this.$el).form('get values', ids)
		},
		/**
		 * Return all form values to their default value. This is the value the
		 * form fields were set to when the page loaded.
		 */
		reset(): void {
			$(this.$el).form('reset')
		},
	},
	render() {
		return (
			<form class="ui form" onSubmit={m.prevent(() => {})}>
				{this.$slots.default}
			</form>
		)
	},
})
